import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { destinazioneDopoLogin } from '../utils/destinazione';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errore, setErrore] = useState('');
  const [caricamento, setCaricamento] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();


  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrore('');
    setCaricamento(true);
    try {
      await login(email, password);
      navigate(destinazioneDopoLogin(location), { replace: true });
    } catch (err) {
      setErrore(err.response?.data?.errore || 'Errore di connessione');
    } finally {
      setCaricamento(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.logoBox}>
          <img src="/logo_boldrin.svg" alt="Studio Boldrin" style={styles.logo} />
        </div>
        <div style={styles.divider}></div>
        <h2 style={styles.title}>Hub digitale</h2>
        <form onSubmit={handleSubmit}>
          {errore && <div style={styles.errore}>{errore}</div>}
          <div style={styles.campo}>
            <label style={styles.label}>Email</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              style={styles.input}
              placeholder="email@esempio.it"
            />
          </div>
          <div style={styles.campo}>
            <label style={styles.label}>Password</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              style={styles.input}
            />
          </div>
          <button type="submit" disabled={caricamento} style={styles.bottone}>
            {caricamento ? 'Accesso in corso...' : 'Accedi'}
          </button>
        </form>
        <div style={styles.footer}>
          {/* Su schermi stretti va a capo solo fra le qualifiche, non dentro */}
          <span style={styles.voce}>Dottori Commercialisti</span> · <span style={styles.voce}>Revisori Legali</span> · <span style={styles.voce}>Avvocati</span>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex', justifyContent: 'center', alignItems: 'center',
    minHeight: '100vh', background: '#232323',
  },
  card: {
    background: 'white', padding: '2.5rem', borderRadius: '12px',
    boxShadow: '0 4px 24px rgba(0,0,0,0.3)', width: '100%', maxWidth: '400px',
    margin: '0 1rem',
  },
  logoBox: { textAlign: 'center', marginBottom: '1rem' },
  // Logo ridotto di circa il 28% (da 40px); max-width per gli schermi stretti, senza deformarlo
  logo: { height: '29px', width: 'auto', maxWidth: '100%', display: 'block', margin: '0 auto' },
  divider: { height: '3px', background: '#D1D179', width: '40px', margin: '0 auto 1.2rem', borderRadius: '2px' },
  title: { margin: '0 0 1.4rem', fontSize: '1.1rem', color: '#232323', textAlign: 'center', fontWeight: 600 },
  campo: { marginBottom: '1rem' },
  label: { fontSize: '0.8rem', color: '#555', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.03em' },
  input: {
    width: '100%', padding: '0.7rem', border: '1px solid #ddd',
    borderRadius: '6px', fontSize: '0.95rem', boxSizing: 'border-box', marginTop: '0.3rem',
    transition: 'border-color 0.15s', outline: 'none',
  },
  bottone: {
    width: '100%', padding: '0.8rem', background: '#232323', color: 'white',
    border: 'none', borderRadius: '6px', fontSize: '0.95rem', cursor: 'pointer',
    marginTop: '0.5rem', fontWeight: 600, transition: 'background 0.15s',
  },
  errore: {
    background: '#fef2f2', color: '#b91c1c', padding: '0.7rem',
    borderRadius: '6px', marginBottom: '1rem', textAlign: 'center', fontSize: '0.85rem',
    border: '1px solid #fecaca',
  },
  voce: { whiteSpace: 'nowrap' },
  footer: {
    textAlign: 'center', marginTop: '1.5rem', paddingTop: '1rem',
    borderTop: '1px solid #f0f0f0', color: '#6b6b6b', fontSize: '0.72rem', lineHeight: 1.5,
  },
};
